<template>
  <div class="mb-4 grid grid-cols-1 gap-x-4 gap-y-4 px-2 md:grid-cols-2">
    <div v-for="i in 2" :key="i">
      <UiSkeletonNews />
    </div>
  </div>
</template>
